<template>
<div>
  <fieldset v-if="showSettingSectionHeader">
    <legend
      class="col-lg-offset-1 col-lg-10"
    >
      <span v-t="'RPC_SETTINGS_TITLE'" />
      <a
        v-tooltip.right="$t('RPC_SETTINGS_TITLE_TT')"
        class="m-l-10 f-s-16"
      >
        &nbsp;&nbsp;<i class="fa fa-question-circle" />
      </a>
    </legend>
  </fieldset>
  <ERPCSettings
    :rpc.sync="rpc"
    :priority-bump="priorityBump"
    :entity-type="entityType"
    @change="onConfigChange"
    @priorityBumpChange="onPriorityBumpChange"
  />
</div>
</template>

<script>

import Field from '@/core/components/LabelAndElement/LabelAndElement';
import nzToggle from '@/core/components/nzToggle/nzToggle';
import ERPCSettings from './ERPCSettings';
import messages from './locales';

export default {
  name: 'RPCSetting',
  components: {
    Field,
    nzToggle,
    ERPCSettings
  }, 

  props: {
    entityType: {
      type: String,
      default: 'account'
    },
    rpcSetting: {
      type: Object,
      default: () => {
        return null;
      }
    },
    rpc: {
      type: Object,
      default: () => {
        return null;
      }
    },
    priorityBump: {
      type: String,
      default: '0'
    },
    showSettingSectionHeader: {
      type: Boolean,
      default: true
    },
    isReadOnly: {
      type: Boolean,
      default: false
    },
  },
  
  data() {
    return {
      componentKey: 0,
      rpcSettingSelected: _.cloneDeep(this.rpcSetting),
      defaultErpcSetting: {
        countAttempsOn: 'DIAL',
        trackConversionBy: 'CAMPAIGN_TARGET',
        minimumNumberOfCalls: 25,
        desiredNumberOfCalls: 200,
        minimumNumberOfHours: null,
        desiredNumberOfHours: 720,
        defaultRatio: 0.70,
        overrideRatio: null,
        overrideAmount: null,
        skipLatestHours: null
      },
      defaultRpcSetting: {
        useERPC: false,
        erpcSetting : this.defaultErpcSetting
      },
    };
  },

  watch: {
    'rpcSetting.erpcSetting'() {
      this.rpcSettingSelected = this.rpcSetting;
      this.reloadSelected();
    },
  },

  created() {
    this.reloadSelected();
  },

  methods: {
    reloadSelected() {
      if (!this.rpcSettingSelected) {
        this.rpcSettingSelected = this.defaultRpcSetting;
      }

      if (!this.rpcSettingSelected.erpcSetting) {
        this.rpcSettingSelected.erpcSetting = { ...this.defaultErpcSetting };
      }

      this.componentKey++;
    },
    onFormChange() {
      this.bubbleChanges();
    },

    onERPCChange(value) {
      if (value) {
        if (!this.rpcSettingSelected.erpcSetting) {
          this.rpcSettingSelected.erpcSetting = this.defaultErpcSetting;
        }
      }

      this.bubbleChanges();
    },

    bubbleChanges() {
      if (this.rpcSettingSelected.erpcSetting.defaultRatio == null || this.rpcSettingSelected.erpcSetting.defaultRatio == 0) {
        this.rpcSettingSelected.erpcSetting.defaultRatio = this.defaultErpcSetting.defaultRatio;
      }

      if (this.rpcSettingSelected.erpcSetting.minimumNumberOfCalls == '') {
        this.rpcSettingSelected.erpcSetting.minimumNumberOfCalls = this.defaultErpcSetting.minimumNumberOfCalls;
      }

      if (this.rpcSettingSelected.erpcSetting.desiredNumberOfCalls == '') {
        this.rpcSettingSelected.erpcSetting.desiredNumberOfCalls = this.defaultErpcSetting.desiredNumberOfCalls;
      }

      if (this.rpcSettingSelected.erpcSetting.desiredNumberOfHours == '') {
        this.rpcSettingSelected.erpcSetting.desiredNumberOfHours = this.defaultErpcSetting.desiredNumberOfHours;
      }

      this.$emit('rpcSettingsChange', this.rpcSettingSelected);
    },

    onConfigChange(value) {
      this.rpc.id = value;
      this.$emit('rpcChange', value);
    },

    onPriorityBumpChange(value) {
      this.$emit('priorityBumpChange', value);
    }
  },

  i18n: {
    messages,
    locale: 'en'
  }
};
</script>